<!-- cv简历信息表-爱好与特长-组件级 -->
<template>
  <div class='detail-wrap'>
    <div class='detail-container'>
      <div class='cv-detail cn'
           v-if='!isEditCn && lang==="cn"'>
        <h4 class='pad-top'>语言能力</h4>
        <div v-if='hobbyDetailCn.languages && hobbyDetailCn.languages.length > 0'>
          <ul v-for='(item, index) in hobbyDetailCn.languages'
              :key='index'
              style="margin-bottom: 32px">
            <li>
              <span class='cv-detail-name'>语言：</span>
              <span class='cv-detail-val'>{{item.name}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>熟练程度：</span>
              <span class='cv-detail-val'>{{item.proficiency && new Map(proficiencyCnMap).get(item.proficiency)}}</span>
            </li>
          </ul>
        </div>
        <h4 class='pad-top'>能力/兴趣/特长</h4>
        <div v-if='hobbyDetailCn.hobbies && hobbyDetailCn.hobbies.length > 0'>
          <ul v-for='(item, index) in hobbyDetailCn.hobbies'
              :key='index'
              style="margin-bottom: 32px">
            <li>
              <span class='cv-detail-name'>兴趣特长名称：</span>
              <span class='cv-detail-val'>{{item.name}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>是否专业训练：</span>
              <span class='cv-detail-val'>{{item.proTraining && new Map(proTrainingCnMap).get(item.proTraining)}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>开始时间：</span>
              <span class='cv-detail-val'>{{item.startTime}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>每周训练周数：</span>
              <span class='cv-detail-val'>{{item.weeksPerYear}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>每周活动时长：</span>
              <span class='cv-detail-val'>{{item.hoursPerWeek}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class='cv-detail en'
           v-if='!isEditEn && lang==="en"'>
        <h4 class='pad-top'>Language Proficiency</h4>
        <div v-if='hobbyDetailEn.languages && hobbyDetailEn.languages.length > 0'>
          <ul v-for='(item, index) in hobbyDetailEn.languages'
              :key='index'>
            <li>
              <span class='cv-detail-name'>Language：</span>
              <span class='cv-detail-val'>{{item.name}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Proficiency：</span>
              <span class='cv-detail-val'>{{item.proficiency && new Map(proficiencyEnMap).get(item.proficiency)}}</span>
            </li>
          </ul>
        </div>
        <h4 class='pad-top'>Talents and Hobbies</h4>
        <div v-if='hobbyDetailEn.hobbies && hobbyDetailEn.hobbies.length > 0'>
          <ul v-for='(item, index) in hobbyDetailEn.hobbies'
              :key='index'>
            <li>
              <span class='cv-detail-name'>Name：</span>
              <span class='cv-detail-val'>{{item.name}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Pro Training：</span>
              <span class='cv-detail-val'>{{item.proTraining && new Map(proTrainingEnMap).get(item.proTraining)}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Started Since：</span>
              <span class='cv-detail-val'>{{item.startTime}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Weeks per Year：</span>
              <span class='cv-detail-val'>{{item.weeksPerYear}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Hours per Week：</span>
              <span class='cv-detail-val'>{{item.hoursPerWeek}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class='cv-form cn'
           v-if='isEditCn && lang==="cn"'>
        <Form ref="formValidateCn"
              :model="formValidateCn"
              :rules="ruleValidateCn"
              :label-width="300">

          <h4 class='pad-top'>语言能力</h4>
          <div v-if="formValidateCn.languages && formValidateCn.languages.length > 0">
            <div v-for="(item, index) in formValidateCn.languages"
                 :key="index">
              <div class="base-form-item">
                <FormItem label="语言："
                          :prop="`languages.${index}.name`"
                          :rules="[{required: true, message: '请输入语言'}]">
                  <Input v-model="item.name"
                         placeholder="请输入语言"
                         clearable></Input>
                </FormItem>
                <FormItem label="熟练程度："
                          :prop="`languages.${index}.proficiency`"
                          :rules="[{required: true, message: '请选择'}]">
                  <Select v-model="item.proficiency"
                          placeholder="请选择"
                          clearable>
                    <Option v-for="item in proficiencyCnMap"
                            :value="item[0]"
                            :key="item[0]">{{item[1] }}
                    </Option>
                  </Select>
                </FormItem>
              </div>
              <div class='oper-del'>
                <a href='javascript: void(0)'
                   @click="delLanguagesItem(index, 'CN')">删除</a>
              </div>
            </div>
          </div>
          <div class="oper-add">
            <a href='javascript: void(0)'
               @click="addLanguagesItem('CN')">添加</a>
          </div>
          <h4 class='pad-top'>能力/兴趣/特长</h4>
          <div v-if="formValidateCn.hobbies && formValidateCn.hobbies.length > 0">
            <div style="margin-top: 24px">
              <div v-for="(item, index) in formValidateCn.hobbies"
                   :key="index">
                <FormItem label="兴趣特长名称："
                          :prop="`hobbies.${index}.name`"
                          :rules="[{required: true, message: '请输入兴趣特长名称'}]">
                  <Input v-model="item.name"
                         placeholder="请输入兴趣特长名称"
                         clearable></Input>
                </FormItem>
                <FormItem label="是否专业训练："
                          :prop="`hobbies.${index}.proTraining`"
                          :rules="[{required: true, message: '请选择'}]">
                  <Select v-model="item.proTraining"
                          placeholder="请选择"
                          clearable>
                    <Option v-for="(item, idx) in proTrainingCnMap"
                            :value="item[0]"
                            :key="idx">{{item[1] }}
                    </Option>
                  </Select>
                </FormItem>
                <FormItem label="开始时间："
                          :prop="`hobbies.${index}.startTime`"
                          :rules="[{required: true, message: '请选择'}]">
                  <date-picker-wrapper type="month"
                                       :editable='false'
                                       format='yyyy-MM'
                                       placeholder="请选择年月，不清楚的可以预估"
                                       v-model="item.startTime"
                                       style="width:100%;"></date-picker-wrapper>
                </FormItem>
                <FormItem label="每年训练周数："
                          :prop="`hobbies.${index}.weeksPerYear`"
                          :rules="[
                            {required: true, message: '请输入平均每年训练的周数'},
                            {pattern: /(^\d+$)|(^\d+\.\d+)$/, message: '请输入平均每年训练的周数'}
                          ]">
                  <Input v-model="item.weeksPerYear"
                         placeholder="请输入平均每年训练的周数"
                         clearable></Input>
                </FormItem>
                <FormItem label="每周活动时长："
                          :prop="`hobbies.${index}.hoursPerWeek`"
                          :rules="[
                            {required: true, message: '请输入平均每周训练的小时数'},
                            {pattern: /(^\d+$)|(^\d+\.\d+)$/, message: '请输入平均每周训练的小时数'}
                          ]">
                  <Input v-model="item.hoursPerWeek"
                         placeholder="请输入平均每周训练的小时数"
                         clearable></Input>
                </FormItem>
              </div>
              <div class='oper-del'>
                <a href='javascript: void(0)'
                   @click="delHobbiesItem(index, 'CN')">删除</a>
              </div>
            </div>
          </div>
          <div class="oper-add">
            <a href='javascript: void(0)'
               @click="addHobbiesItem('CN')">添加</a>
          </div>
          <div class="sub-btn"
               style="margin-top: 24px">
            <Button type='primary'
                    :loading='hasSaveCn'
                    @click="saveCn">保存
            </Button>
          </div>
        </Form>
      </div>

      <div class='cv-form en'
           v-if='isEditEn && lang==="en"'>
        <Form ref="formValidateEn"
              :model="formValidateEn"
              :rules="ruleValidateEn"
              :label-width="300">

          <div class="base-form-item">
            <h4 class='pad-top'>Language Proficiency</h4>
            <div v-if="formValidateEn.languages && formValidateEn.languages.length > 0">
              <div v-for="(item, index) in formValidateEn.languages"
                   :key="index">
                <FormItem label="Language："
                          :prop="`languages.${index}.name`"
                          :rules="[{required: true, message: 'please enter language'}]">
                  <Input v-model="item.name"
                         placeholder="please enter language"
                         clearable></Input>
                </FormItem>
                <FormItem label="Proficiency："
                          :prop="`languages.${index}.proficiency`"
                          :rules="[{required: true, message: 'please select'}]">
                  <Select v-model="item.proficiency"
                          placeholder="please select"
                          clearable>
                    <Option v-for="item in proficiencyCnMap"
                            :value="item[0]"
                            :key="item[0]">{{item[1] }}
                    </Option>
                  </Select>
                </FormItem>
                <div class='oper-del'>
                  <a href='javascript: void(0)'
                     @click="delLanguagesItem(index, 'EN')">Delete</a>
                </div>
              </div>
            </div>
            <div class="oper-add">
              <a href='javascript: void(0)'
                 @click="addLanguagesItem('EN')">Add</a>
            </div>
            <h4 class='pad-top'>Talents and Hobbies</h4>
            <div style="margin-top: 24px">
              <div v-if="formValidateEn.hobbies && formValidateEn.hobbies.length > 0">

                <div v-for="(item, index) in formValidateEn.hobbies"
                     :key="index">

                  <FormItem label="Name："
                            :prop="`hobbies.${index}.name`"
                            :rules="[{required: true, message: 'please enter name'}]">
                    <Input v-model="item.name"
                           placeholder="please enter name"
                           clearable></Input>
                  </FormItem>
                  <FormItem label="Pro Training："
                            :prop="`hobbies.${index}.proTraining`"
                            :rules="[{required: true, message: 'please select'}]">
                    <Select v-model="item.proTraining"
                            placeholder="please select"
                            clearable>
                      <Option v-for="item in proTrainingEnMap"
                              :value="item[0]"
                              :key="item[0]">{{item[1] }}
                      </Option>
                    </Select>
                  </FormItem>
                  <FormItem label="Started Since："
                            :prop="`hobbies.${index}.startTime`"
                            :rules="[{required: true, message: '请选择'}]">
                    <date-picker-wrapper type="month"
                                         :editable='false'
                                         format='yyyy-MM'
                                         placeholder="(yyyy.mm. approximate if unsure)"
                                         v-model="item.startTime"
                                         style="width:100%;"></date-picker-wrapper>
                  </FormItem>
                  <FormItem label="Weeks per Year："
                            :prop="`hobbies.${index}.weeksPerYear`"
                            :rules="[
                            {required: true, message: 'please enter average weeks of training per year'},
                            {pattern: /(^\d+$)|(^\d+\.\d+)$/, message: 'please enter average weeks of training per year'}
                          ]">
                    <Input v-model="item.weeksPerYear"
                           placeholder="please enter average weeks of training per year"
                           clearable></Input>
                  </FormItem>
                  <FormItem label="Hours per Week："
                            :prop="`hobbies.${index}.hoursPerWeek`"
                            :rules="[
                            {required: true, message: 'please enter average hours of training per week'},
                            {pattern: /(^\d+$)|(^\d+\.\d+)$/, message: 'please enter average hours of training per week'}
                          ]">
                    <Input v-model="item.hoursPerWeek"
                           placeholder="please enter average hours of training per week"
                           clearable></Input>
                  </FormItem>
                  <div class='oper-del'>
                    <a href='javascript: void(0)'
                       @click="delHobbiesItem(index, 'EN')">Delete</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="oper-add">
              <a href='javascript: void(0)'
                 @click="addHobbiesItem('EN')">Add</a>
            </div>
            <div class="sub-btn"
                 style="margin-top: 24px">
              <Button type='primary'
                      :loading='hasSaveEn'
                      @click="saveEn">Save
              </Button>
              <!-- <a href='javascript: void(0)'
                 @click="saveCn">保存</a> -->
            </div>
          </div>
        </Form>
      </div>
      <div class='cv-btn cn'
           v-if='lang==="cn"'>
        <a href='javascript: void(0)'
           @click="goEdit('CN')">{{isEditCn ? '返回' : '编辑'}}</a>
      </div>
      <div class='cv-btn en'
           v-if='lang==="en"'>
        <a href='javascript: void(0)'
           @click="goEdit('EN')">{{isEditEn ? 'back' : 'Edit'}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import cvService from '@/api/undergraduate/cv'
import { proficiencyCnMap, proficiencyEnMap, proTrainingCnMap, proTrainingEnMap } from '../constants'
import './cv-detail.less'
import DatePickerWrapper from '@/components/date/DatePickerWrapper'

export default {
  name: '',
  props: {
    lang: {
      type: String,
      default: ''
    }
  },
  components: { DatePickerWrapper },
  data () {
    return {
      // 熟练程度映射
      proficiencyCnMap,
      proficiencyEnMap,
      // 是否专业训练映射
      proTrainingCnMap,
      proTrainingEnMap,
      // 详细信息
      hobbyDetailCn: {
        languages: [
          // {
          //   name: '',
          //   proficiency: ''
          // }
        ],
        hobbies: [
          // {
          //   name: '',
          //   proTraining: false,
          //   startTime: '',
          //   weeksPerYear: 0,
          //   hoursPerWeek: 0
          // }
        ]
      },
      hobbyDetailEn: {},
      // 是否编辑状态标识
      isEditEn: false,
      isEditCn: false,
      // Cn表单
      formValidateCn: {
        languages: [{}],
        hobbies: [{}]
      },
      ruleValidateCn: {},
      ruleValidateEn: {},
      // En表单
      formValidateEn: {
        languages: [{}],
        hobbies: [{}]
      },
      // loading-表单提交-避免重复提交
      hasSaveCn: false,
      hasSaveEn: false
    }
  },
  computed: {},
  mounted () {
    this.$nextTick(() => {
      if (this.lang === 'cn') {
        this.getHobbyDetailCn()
      }
      if (this.lang === 'en') {
        this.getHobbyDetailEn()
      }
    })
  },
  methods: {
    // 获取爱好与特长-cn
    getHobbyDetailCn () {
      cvService.cvHobbyDetailCn().then(res => {
        if (res.data.model) {
          this.hobbyDetailCn = res.data.model
          for (let i = 0; i < this.hobbyDetailCn.hobbies.length; i++) {
            this.hobbyDetailCn.hobbies[i].proTraining = (this.hobbyDetailCn.hobbies[i].proTraining || String(this.hobbyDetailCn.hobbies[i].proTraining) === 'false') ? String(this.hobbyDetailCn.hobbies[i].proTraining) : ''
          }
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    },
    // 获取爱好与特长-en
    getHobbyDetailEn () {
      cvService.cvHobbyDetailEn().then(res => {
        if (res.data.model) {
          this.hobbyDetailEn = res.data.model
          if (this.hobbyDetailEn.hobbies) {
            for (let i = 0; i < this.hobbyDetailEn.hobbies.length; i++) {
              this.hobbyDetailEn.hobbies[i].proTraining = (this.hobbyDetailEn.hobbies[i].proTraining || String(this.hobbyDetailEn.hobbies[i].proTraining) === 'false') ? String(this.hobbyDetailEn.hobbies[i].proTraining) : ''
            }
          }
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    },
    // 编辑-返回
    goEdit (type) {
      const map = { CN: 'Cn', EN: 'En' }
      let l = map[type]
      cvService[`cvHobbyDetail${l}`]().then(res => {
        if (this[`isEdit${l}`]) {
          this[`hobbyDetail${l}`] = res.data.model
          for (let i = 0; i < this[`hobbyDetail${l}`].hobbies.length; i++) {
            this[`hobbyDetail${l}`].hobbies[i].proTraining = (this[`hobbyDetail${l}`].hobbies[i].proTraining || String(this[`hobbyDetail${l}`].hobbies[i].proTraining) === 'false') ? String(this[`hobbyDetail${l}`].hobbies[i].proTraining) : ''
          }
        } else {
          this[`formValidate${l}`] = res.data.model
          for (let i = 0; i < this[`formValidate${l}`].hobbies.length; i++) {
            this[`formValidate${l}`].hobbies[i].proTraining = (this[`formValidate${l}`].hobbies[i].proTraining || String(this[`formValidate${l}`].hobbies[i].proTraining) === 'false') ? String(this[`formValidate${l}`].hobbies[i].proTraining) : ''
          }
        }
        this[`isEdit${l}`] = !this[`isEdit${l}`]
      })
    },
    // 保存
    saveCn () {
      if (this.hobbyDetailCn.languages && this.hobbyDetailCn.languages.length === 0 && this.formValidateCn.hobbies && this.formValidateCn.hobbies.length === 0) {
        this.hasSaveCn = true
        cvService.cvSaveHobbyCn(this.formValidateCn).then(res => {
          this.hasSaveCn = false
          this.$ugd_message('保存成功', 'success')
          this.goEdit('CN')
        }).catch(error => {
          this.hasSaveCn = false
          this.$ugd_message(error.message, 'error')
        })
        return
      }
      this.$refs.formValidateCn.validate((valid) => {
        if (valid) {
          this.hasSaveCn = true
          cvService.cvSaveHobbyCn(this.formValidateCn).then(res => {
            this.hasSaveCn = false
            this.$ugd_message('保存成功', 'success')
            this.goEdit('CN')
          }).catch(error => {
            this.hasSaveCn = false
            this.$ugd_message(error.message, 'error')
          })
        }
      })
    },
    // Save
    saveEn () {
      if (this.hobbyDetailEn.languages && this.hobbyDetailEn.languages.length === 0 && this.formValidateEn.hobbies && this.formValidateEn.hobbies.length === 0) {
        this.hasSaveEn = true
        cvService.cvSaveHobbyEn(this.formValidateEn).then(res => {
          this.hasSaveEn = false
          this.$ugd_message('Save Success', 'success')
          this.goEdit('EN')
        }).catch(error => {
          this.hasSaveEn = false
          this.$ugd_message(error.message, 'error')
        })
        return
      }
      this.$refs.formValidateEn.validate((valid) => {
        if (valid) {
          this.hasSaveEn = true
          cvService.cvSaveHobbyEn(this.formValidateEn).then(res => {
            this.hasSaveEn = false
            this.$ugd_message('Save Success', 'success')
            this.goEdit('EN')
          }).catch(error => {
            this.hasSaveEn = false
            this.$ugd_message(error.message, 'error')
          })
        }
      })
    },
    delLanguagesItem (index, type) {
      if (type === 'CN') {
        this.formValidateCn.languages.splice(index, 1)
      } else if (type === 'EN') {
        this.formValidateEn.languages.splice(index, 1)
      }
    },
    addLanguagesItem (type) {
      let items = {
        name: undefined,
        proficiency: undefined
      }
      if (type === 'CN') {
        this.formValidateCn.languages.push(items)
      } else if (type === 'EN') {
        this.formValidateEn.languages.push(items)
      }
    },
    addHobbiesItem (type) {
      let data = {
        name: undefined,
        proTraining: undefined,
        startTime: undefined,
        weeksPerYear: undefined,
        hoursPerWeek: undefined
      }
      if (type === 'CN') {
        this.formValidateCn.hobbies.push(data)
      } else if (type === 'EN') {
        this.formValidateEn.hobbies.push(data)
      }
    },
    delHobbiesItem (index, type) {
      if (type === 'CN') {
        this.formValidateCn.hobbies.splice(index, 1)
      } else if (type === 'EN') {
        this.formValidateEn.hobbies.splice(index, 1)
      }
    }
  }
}
</script>
<style lang='less' scoped>
</style>
